import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import { useAuth } from '../auth';

const CAPS = [
  { k: 'n456', label: '456', perm: null },
  { k: 'copertura', label: 'Copertura', perm: 'ssmate_copertura' },
  { k: 'lucchetto', label: 'Lucchetto', perm: 'ssmate' },
  { k: 'vodafone', label: 'Vodafone', perm: 'gea' },
  { k: 'dominio', label: 'Dominio', perm: 'ssmate' },
  { k: 'vicine', label: 'Vicine', perm: null },
];

export default function AgentiSalesmateCard() {
  const { user, can } = useAuth();
  const isAdmin = user?.ruolo === 'admin';
  const [items, setItems] = useState(null);   // null = in caricamento

  const load = useCallback(() => {
    axios.get(`${API}/agenti`).then(r => setItems(r.data?.items || []))
      .catch(() => { setItems([]); toast.error('Impossibile caricare gli agenti'); });
  }, []);
  useEffect(() => { load(); }, [load]);

  const patch = async (username, body) => {
    try { await axios.patch(`${API}/agenti/${encodeURIComponent(username)}`, body); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore aggiornamento'); }
  };
  const elimina = async (username) => {
    if (!window.confirm(`Eliminare l'agente ${username}?`)) return;
    try { await axios.delete(`${API}/agenti/${encodeURIComponent(username)}`); toast.success('Agente eliminato'); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
  };

  return (
    <div className="imp-card imp-card--wide">
      <h3 className="imp-card-title">Agenti SalesMate</h3>
      <p style={{ margin: '0 0 14px', color: '#64748b', fontSize: 13 }}>
        Agenti registrati su <b>/agente</b> con le proprie credenziali SalesMate. Puoi abilitarli/disabilitarli e gestire i servizi.
        Copertura e Lucchetto girano sull'account SalesMate del singolo agente; 456 e Vodafone usano le risorse centrali.
      </p>
      {items === null ? (
        <div style={{ color: '#94a3b8', fontSize: 13 }}>Caricamento…</div>
      ) : items.length === 0 ? (
        <div style={{ color: '#94a3b8', fontSize: 13 }}>Nessun agente registrato.</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', fontSize: 13 }}>
            <thead>
              <tr style={{ textAlign: 'left', color: '#64748b' }}>
                <th>Agente</th><th>Servizi</th><th>Ultimo accesso</th><th>Stato</th><th></th>
              </tr>
            </thead>
            <tbody>
              {items.map(a => (
                <tr key={a.username} style={{ borderTop: '1px solid #f1f5f9', opacity: a.attivo ? 1 : 0.5 }}>
                  <td style={{ fontWeight: 600 }}>
                    {a.nome || a.username}
                    {a.nome && <div style={{ fontWeight: 400, color: '#94a3b8', fontSize: 11 }}>{a.username}</div>}
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {CAPS.map(c => (c.perm === null || can(c.perm)) ? (
                      <label key={c.k} style={{ display: 'inline-flex', gap: 4, alignItems: 'center', fontSize: 12, color: '#475569', marginRight: 8 }}>
                        <input type="checkbox" checked={!!a.capabilities?.[c.k]}
                          onChange={e => patch(a.username, { capabilities: { [c.k]: e.target.checked } })} /> {c.label}
                      </label>
                    ) : null)}
                    {isAdmin && (
                      <label
                        title="Quando gli account di sistema esauriscono i crediti, il macinatore usa anche i crediti di questo agente (di norma di notte)."
                        style={{ display: 'inline-flex', gap: 4, alignItems: 'center', fontSize: 12, color: '#475569', marginRight: 8 }}
                      >
                        <input
                          type="checkbox"
                          checked={!!a.pool_sistema}
                          onChange={e => patch(a.username, { pool_sistema: e.target.checked })}
                        /> Nel pool di sistema
                      </label>
                    )}
                    {isAdmin && a.capabilities?.vicine && (
                      <span style={{ display: 'inline-flex', gap: 5, alignItems: 'center', fontSize: 12, color: '#475569' }}
                        title="Crediti Vicine (Google API) al mese per questo agente. Vuoto = usa il default globale delle Impostazioni.">
                        Vicine/mese:
                        <input type="number" min="0" placeholder="def" key={a.username + '-' + (a.vicine_crediti_mese ?? '')}
                          defaultValue={a.vicine_crediti_mese ?? ''}
                          onBlur={e => { const v = e.target.value.trim(); patch(a.username, { vicine_crediti_mese: v === '' ? -1 : Number(v) }); }}
                          style={{ width: 54, padding: '2px 6px', fontSize: 12 }} />
                        <span style={{ color: '#94a3b8' }}>({a.vicine_usati ?? 0} usati)</span>
                      </span>
                    )}
                  </td>
                  <td style={{ whiteSpace: 'nowrap', color: '#64748b' }}>{a.last_login ? new Date(a.last_login).toLocaleString('it-IT') : '—'}</td>
                  <td style={{ fontWeight: 700, color: a.attivo ? '#16a34a' : '#94a3b8' }}>{a.attivo ? 'Attivo' : 'Disabilitato'}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <button className="btn btn-sm" onClick={() => patch(a.username, { attivo: !a.attivo })}>{a.attivo ? 'Disabilita' : 'Abilita'}</button>{' '}
                    <button className="btn btn-sm" onClick={() => elimina(a.username)} style={{ color: '#b91c1c' }}>Elimina</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
